import { useWaterTable } from "@/api/districts";
import { getWaterColumns } from "@/components/meters/meter-columns";
import { GenericMeterTab } from "@/components/meters/meter-tab";
import { useTableUrlState } from "@/components/table/use-table-url-state";
import { useDistrict } from "@/contexts/district-context";

export function WaterMetersPage() {
	const { districtId } = useDistrict();
	const {
		page,
		pageSize,
		search,
		ordering,
		setPage,
		setPageSize,
		setSearch,
		setOrdering,
	} = useTableUrlState("-last_reading_date");

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<GenericMeterTab
				page={page}
				pageSize={pageSize}
				setPage={setPage}
				setPageSize={setPageSize}
				search={search}
				setSearch={setSearch}
				ordering={ordering}
				setOrdering={setOrdering}
				getColumns={getWaterColumns}
				useTableQuery={useWaterTable}
				districtId={districtId}
			/>
		</div>
	);
}
